<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权限管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>权限管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class='label-span'>
                    <label class="label">手机号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="手机号码" class="handle-input mr15"></el-input>  
                </span>
                <span class='label-span'>
                    <label class="label">用户名称</label> 
                    <el-input v-model.trim="query.loginName" placeholder="用户名称" class="handle-input mr15"></el-input>  
                </span>
                <span class='label-span'>
                    <label class="label">角色名称</label> 
                    <el-select v-model="query.rcode"  placeholder="角色名称" filterable  clearable class="handle-select mr15">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"   @click="refreshSearch">重置</el-button>
                <el-button type="primary" icon="el-icon-edit" class="mr10"   @click="changeOper">角色批量变更</el-button>
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange"  >  
                <el-table-column type="selection" width="45" align="center"></el-table-column> 
                <el-table-column prop="loginName" min-width="80" align="left" label="用户名称"> </el-table-column>  
                <el-table-column prop="phone" min-width="80" align="center" label="手机号码"> </el-table-column> 
                <el-table-column prop="rname" min-width="90" align="left" label="角色名称"></el-table-column> 
                <el-table-column prop="createTime" min-width="100" align="left" label="创建时间"></el-table-column> 
                <el-table-column label="操作" min-width="100" align="center" fixed="right">
                    <template slot-scope="scope">  
                         <span class='tableOperBtn' @click="handleEdit( scope.$index, scope.row)" ><i class='el-icon-edit'></i> 角色变更</span>
                          
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                       background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50,200]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="角色变更" :modal-append-to-body='false' :visible.sync="editPlusVisible" top="80px" width="380px">
            <el-form ref="form" :model="form3" label-width="70px" @submit.native.prevent="saveForm"> 
                <el-form-item label="用户名称" >   
                    <span>
                        {{form3.names}}
                    </span>
                </el-form-item>    
                <el-form-item label="角色变更" >   
                    <el-select v-model="form3.rcode"  > 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>    
                </el-form-item>      
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">{{ isSubmitting ? '提交中...' : '提交' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,changeRole} from '../../api/operUserRole';   
import {fetchSelect} from '../../api/operRole';  
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'' }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            treeData:[],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            showVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            treeVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                delFag:'0', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() { 
    }, 
    //页面加载方法
    mounted: function () {  
         //查询列表
        this.getSelect();
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'phone'); 
            this.$set(this.query, 'loginName');   
            this.$set(this.query, 'rcode'); 
            this.handleSearch();
        }, 
        treeShow(id){
            this.getTreeData(id);
            this.treeVisible = true;
        },
        getTreeData(id){
            let data = {};
            data.stationId = this.stationId;  
            getTreeData(data).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },

        //获取下拉框数据
        getSelect(){    
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 
        showIcon(){
            this.showVisible=true;
        },

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
        //选择不同渠道类型显示不同弹框
        addChange(){  
            if(this.form1.channelType==1){
                this.addVisible=false;
                this.addPlusVisible=true;
            }
            if(this.form1.channelType==0){
                this.addVisible=true;
                this.addPlusVisible=false
            }
        }, 

        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.rcode ){
                this.isSubmitting = false;
                this.$message.error("请选择角色编码");
                return;
            }
            if( !this.form1.rname ){
                this.isSubmitting = false;
                this.$message.error("请填写角色名称");
                return;
            } 
            saveForm(this.form1).then(res => { 
                this.isSubmitting = false;
                if(res.code=='200'){
                    this.addVisible = false;
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },

        
        //更改权限
        changeOper() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要变更角色的用户");
                return;
            }  
            let ids = '';
            let names = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ',';
                names += this.multipleSelection[i].loginName + '，';
            } 
            this.form3.id = ids.substr(0,ids.length-1);
            this.form3.names = names.substr(0,names.length-1);  
            this.editPlusVisible = true;
        },

        // 编辑操作
        handleEdit(index, row) { 
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data;  
                    this.form3 = row;   
                    this.form3.names = row.loginName;   
                    this.multipleSelection = [];
                    this.editPlusVisible = true;
                }
            }); 
        },

         
        // 保存更改
        saveEdit() {    
            changeRole(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) { 
            let data = {};
            data.id = row.id;
            data.delFag = row.delFag;
            data.stationId = this.stationId; 
            data.mid = this.mid; 
            var tips="禁用";
            if(row.delFag==0){
                tips="启用";
            } 
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{ 
                    this.$message.error(tips+'失败');
                } 
            }); 
        },

        
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确定要删除该菜单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
</style>
